import {datadogRum} from '@datadog/browser-rum';

import {type BuildrzConfig} from '../../load_config';

export default function initDatadogRum(
  config: BuildrzConfig,
  user: string,
  organization: string,
): void {
  if (
    config.datadogRumAppId &&
    config.datadogRumClientToken &&
    config.datadogRumServiceName
  ) {
    datadogRum.init({
      applicationId: config.datadogRumAppId,
      clientToken: config.datadogRumClientToken,
      site: 'datadoghq.com',
      service: config.datadogRumServiceName,
      allowFallbackToLocalStorage: true,
      allowedTracingUrls: ['*'],
      // Specify a version number to identify the deployed version of your application in Datadog
      // version: '1.0.0',
      sampleRate: 100,
      trackInteractions: true,
      defaultPrivacyLevel: 'mask-user-input',
      beforeSend: event => {
        event.context = {
          ...event.context,
          user,
          organization,
        };
      },
    });
    datadogRum.setUser({
      email: user,
      organization: organization,
    });
  }
}
